module.exports = __webpack_public_path__ + "e52f2619c1cc54d8841379d0ed022cd8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/assos.svg
// module id = 730
// module chunks = 0